<template>
  <div style="position: relative;">
    <input 
      type="checkbox"
      class="ti-checkbox" 
      :name="name"
      v-model="model"
    >
    <label 
      :for="name" 
      class="instr-label --capitalise"
      :class="{incompatible: incompatible}"
    >
      <slot></slot>
    </label>
  </div>
</template>

<script>
export default {
  props: {
    name: String,
    value: Boolean,
    mutation: String,
    incompatible: {
      type: Boolean,
      default: false
    }
  },

  computed: {
    model: {
      get () {
        return this.value;
      },
      set(value) {
        this.$store.commit(this.mutation, value);
      }
    }
  }
}
</script>

<style scoped>
div {
  position: relative;
}

.ti-checkbox {
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  margin: 0;
  opacity: 0;
  cursor: pointer;
}

.incompatible {
  background: #a5614c;
}
</style>
